export type NativePlatform = "ios" | "android";
export interface MobileTestResult {
  appId: string;
  runId: string;
  requestKey: string;
  state:
    | "running"
    | "passed"
    | "assertion-failed"
    | "driver-error"
    | "timed-out"
    | "cancelled"
    | "interrupted";
  artifacts: { name: string; sha256: string; byteLength: number }[];
  artifactsDeletedAt?: number;
}
export interface MobileNativeRun {
  runId: string;
  worldKey: string;
  appId: string;
  sessionId: string;
  sourceDigest: string;
  platform: NativePlatform;
  packageId: string;
  resourceOwnership: "created-for-run";
  revision: number;
  state: "queued" | "preparing" | "ready" | "failed" | "ending" | "ended";
  targetId: string | null;
  runtimeFingerprint: string | null;
  nativeBinarySha256: string | null;
  loadedSourceDigest: string | null;
  inputEnabled: boolean;
  streamActive: boolean;
  ownedResourcesReleased: boolean;
  controlGeneration: number;
  controller: "agent" | "human";
  diagnostic: string | null;
}
export type NativeOperation =
  | { type: "tap"; ref: string }
  | { type: "type"; ref: string; text: string }
  | { type: "point"; x: number; y: number }
  | { type: "key"; key: "return" | "delete" };
export type MobileNativeRequest =
  | {
      action: "testRun";
      appId: string;
      runId: string;
      sourceDigest: string;
      nativeBinarySha256: string;
      targetId: string;
      controlGeneration: number;
      suite: { memberId: string; sha256: string };
      parameters: { TASK_TITLE: string };
      requestKey: string;
      maxDurationMs: number;
      evidenceRetention: "until-run-stop";
    }
  | { action: "testResult"; appId: string; runId: string; requestKey: string }
  | { action: "testArtifact"; appId: string; runId: string; requestKey: string; name: string }
  | {
      action: "start";
      appId: string;
      sessionId: string;
      sourceDigest: string;
      platform: NativePlatform;
      requestKey: string;
      buildProfile: "development";
      target: { allocation: "new-test-device" };
    }
  | { action: "sessionRuns"; sessionId: string }
  | { action: "run" | "observe" | "frame"; appId: string; runId: string }
  | { action: "stop" | "restartApp"; appId: string; runId: string; requestKey: string }
  | {
      action: "reloadSource";
      appId: string;
      runId: string;
      sourceDigest: string;
      requestKey: string;
    }
  | {
      action: "control";
      appId: string;
      runId: string;
      controller: "human" | "agent";
      requestKey: string;
    }
  | {
      action: "act";
      appId: string;
      runId: string;
      observationId: string;
      controlGeneration: number;
      operation: NativeOperation;
      requestKey: string;
    };

export const NATIVE_PREVIEW_PREFIX = "native:";
export const nativePreviewRunId = (resourceId: string | null | undefined): string | null =>
  resourceId?.startsWith(NATIVE_PREVIEW_PREFIX) &&
  /^[a-z0-9]{10,80}$/.test(resourceId.slice(NATIVE_PREVIEW_PREFIX.length))
    ? resourceId.slice(NATIVE_PREVIEW_PREFIX.length)
    : null;
